/**
 * @file 用户点击赎回按钮后的流程控制
 */
import { OrderResultModal } from './orderResult';
import { Process, UnstakeCoinInfoStore, GasStore } from '@/types/unstake';
import { TipModal } from '@/components';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { useFm } from '@web3/base-hooks';
import { useParams } from '@web3/base-hooks';
import dayjs from 'dayjs';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';
import { DelayRedeemInfo } from '@/types/unstake';
import { ShowType } from '@/types/account';
import { appPath } from '@web3/base-utils';
import styles from './index.module.scss';

interface Props {
  process: Process;
  slippage: string;
  unstakeAmount: string;
  gasStore: GasStore;
  selectCoinList: string[];
  unstakeCoinAmountStore: UnstakeCoinInfoStore;
  slippageIsLost: boolean;
  orderCode: string;
  delayRedeemInfo: DelayRedeemInfo;
  showType: ShowType;
  onChangeProcess: (v: Process) => void;
  onChangeShowType: (v: ShowType) => void;
}

export const UnstakeProcess = (props: Props) => {
  const {
    process,
    slippage,
    unstakeAmount,
    unstakeCoinAmountStore,
    gasStore,

    selectCoinList,
    slippageIsLost,
    orderCode,
    showType,
    delayRedeemInfo,
    onChangeProcess,
    onChangeShowType,
  } = props;
  const { locale } = useParams();
  const fm = useFm();
  const { poolInfo } = usePoolInfoContext();

  return (
    <>
      {/* bbSOL赎回与预估价差较大提示 */}
      {process === Process.SolLoss && (
        <TipModal
          show
          onClose={() => onChangeProcess(Process.None)}
          onConfirm={() => {
            onChangeProcess(Process.Confirm);
            onChangeShowType(
              showType === ShowType.DelayUnStake
                ? ShowType.ConfimDelayUnStake
                : ShowType.ConfirmUnstake
            );
          }}
          title={fm('redemptionTip')}
          currentBtnProps={styles.currentBtn}
          content={
            <>
              {fm('solAlertMessage')}
              <span
                className={styles.extraText}
                onClick={() => {
                  if (window.top) {
                    window.top.open(
                      `/${locale}/help-center/article/Agreement-for-Web3-Earn`
                    );
                  }
                }}
              >
                {fm('bybitWeb3ServiceTerm')}
              </span>
            </>
          }
          buttonText={fm('continueRedemption')}
        ></TipModal>
      )}
      {/* 赎回金额延迟到账提醒 */}
      {process === Process.Delay && (
        <TipModal
          show
          data-spm-even={Event.Web3PageView}
          data-spm-data={JSON.stringify({
            page_name: 'StakingWeb_bbSOLdelayRedeemNotice',
          })}
          currentBtnProps={styles.currentBtn}
          onClose={() => onChangeProcess(Process.None)}
          onConfirm={() => {
            scTrack(Event.Web3UserClick, {
              page_name: 'StakingWeb_bbSOLdelayRedeemNotice',
              button_name: 'redeem_delay_confirm',
            });
            onChangeShowType(
              showType === ShowType.DelayUnStake
                ? ShowType.ConfimDelayUnStake
                : ShowType.ConfirmUnstake
            );
            onChangeProcess(Process.Confirm);
          }}
          content={fm('expectedRedemptionNotice', {
            num: Math.ceil(
              dayjs
                .duration(poolInfo.poolExtendDTO.delayTime, 'seconds')
                .asDays()
            ),
            text: (
              <span
                className={styles.extraText}
                onClick={() => {
                  if (window.top) {
                    window.top.open(`/${locale}${appPath}/pool/${poolInfo.id}`);
                  }
                }}
              >
                {fm('see_more')}
              </span>
            ),
          })}
          buttonText={fm('continueRedeeming')}
        ></TipModal>
      )}
      {/* 滑点损失提醒 */}
      {process === Process.Slippage && (
        <TipModal
          show
          onClose={() => onChangeProcess(Process.None)}
          currentBtnProps={styles.currentBtn}
          onConfirm={() => {
            if (poolInfo.poolExtendDTO.delayTime) {
              onChangeProcess(Process.Delay);
              return;
            }
            onChangeShowType(
              showType === ShowType.DelayUnStake
                ? ShowType.ConfimDelayUnStake
                : ShowType.ConfirmUnstake
            );
            onChangeProcess(Process.Confirm);
          }}
          content={
            <>
              {fm('redemptionRiskAcceptanceTip', {
                num: slippage,
              })}
              <span
                className={styles.extraText}
                onClick={() => {
                  if (window.top) {
                    window.top.open(
                      `/${locale}/help-center/article/Agreement-for-Web3-Earn`
                    );
                  }
                }}
              >{` <${fm('bybitWeb3EarnTerms')}>`}</span>
            </>
          }
          buttonText={fm('continueRedeeming')}
        ></TipModal>
      )}

      {/* 质押结果弹窗 */}
      {process === Process.Result && (
        <OrderResultModal
          show
          slippage={slippage}
          unstakeAmount={unstakeAmount}
          gasStore={gasStore}
          slippageIsLost={slippageIsLost}
          orderCode={orderCode}
          unstakeCoinAmountStore={unstakeCoinAmountStore}
          selectCoinList={selectCoinList}
          showType={showType}
          delayRedeemInfo={delayRedeemInfo}
        />
      )}
    </>
  );
};
